import React from 'react';
import proptypes from 'prop-types';
import {
  TileContent, Tile, Typography, TileMedia,
  SkeletonBlock, Skeleton
} from '@one-thd/sui-atomic-components';
import { getPaintContainerSize, getPaintImageUrl } from '../../super-sku-util';
import { CardPrice } from './components/CardPrice';

const { bool, func, shape, string } = proptypes;

export const Card = (props) => {
  const {
    isDotComColorEligible,
    isSelected,
    attributeValue,
    onClick,
    swatchCardCombinationDetails,
    centeredCards,
    hexColor,
    attributeName,
    paintBrand,
    isPaintReorder
  } = props;

  const { image, pricing } = swatchCardCombinationDetails || {};

  let imageUrl = image;
  let isSheen;
  let containerSize;
  if (isDotComColorEligible || isPaintReorder) {
    imageUrl = getPaintImageUrl(attributeValue, attributeName, paintBrand);
    isSheen = attributeName === 'Sheen';
    containerSize = getPaintContainerSize(attributeValue);
  }

  const NO_IMAGE_ATTRIBUTES = ['Sheen', 'Brand Name', 'Color/Finish', 'Paint Type'];
  const showImage = imageUrl || !NO_IMAGE_ATTRIBUTES.includes(attributeName);

  const getImageWrapperClass = (size, hasPrice) => {
    if (pricing) return '70%';
    switch (size) {
    case 'sample':
      return '35%';
    case 'quart':
      return '40%';
    case 'gallon':
      return '55%';
    case '5gallon':
      return '50%';
    default:
      return 'auto';
    }
  };
  const hasCombinationDetails = Object.keys(swatchCardCombinationDetails || {}).length !== 0;
  const loading = hasCombinationDetails && !imageUrl && showImage;

  if (loading) {
    return (
      <Skeleton>
        <SkeletonBlock aspect="square" />
      </Skeleton>
    );
  }

  return (!hasCombinationDetails ? null
    : (
      <div className="sui-pr-2">
        <Tile
          onClick={onClick}
          selected={isSelected}
          value={attributeValue}
          variant="outline"
          disabled={false}
          unavailable={false}
          grow={false}
        >
          <TileContent alignItems="center" orientation="vertical">
            <div className="sui-h-28 sui-w-24 sui-flex sui-flex-col sui-items-center">
              {isSheen ? (
                <TileMedia
                  src={imageUrl}
                  style={hexColor ? { background: `#${hexColor}` } : undefined}
                />
              ) : (
                showImage && (
                  <div
                    className="sui-w-20 sui-h-1/2 sui-m-2 sui-flex sui-justify-center sui-items-end"
                  >
                    <img
                      src={imageUrl}
                      alt={attributeValue}
                      height="auto"
                      width={getImageWrapperClass(containerSize)}
                    />
                  </div>
                )
              )}
              <div className="sui-h-1/2">
                <div className="sui-mt-1">
                  <Typography variant="body-sm" align="center">{attributeValue}</Typography>
                </div>
                {pricing && <CardPrice pricing={pricing} />}
              </div>
            </div>
          </TileContent>
        </Tile>
      </div>
    )
  );
};

Card.displayName = 'Card';

Card.propTypes = {
  attributeValue: string.isRequired,
  centeredCards: bool,
  hexColor: string,
  isDotComColorEligible: bool,
  isSelected: bool,
  onClick: func.isRequired,
  swatchCardCombinationDetails: shape({
    image: string,
    pricing: shape({
      message: string,
      isSpecialPrice: bool,
      strikeThroughPriceForMap: bool,
      price: shape({
        formatted: string,
        dollars: string,
        cents: string,
        lessThanDollar: bool
      })
    })
  }).isRequired,
  attributeName: string,
  paintBrand: string,
  isPaintReorder: bool,
};

Card.defaultProps = {
  centeredCards: false,
  hexColor: '',
  isDotComColorEligible: false,
  isSelected: false,
  attributeName: '',
  isPaintReorder: false,
  paintBrand: ''
};
